import _ from "lodash";
import * as api from "services/api";
import history from "../../../../history";

export const EDIT_TAG_COLOR = "[TAG_COLOR EDIT] EDIT_TAG_COLOR";
export const EDIT_TAG_COLOR_SUCCESS =
  "[TAG_COLOR EDIT] EDIT_TAG_COLOR_SUCCESS";
export const EDIT_TAG_COLOR_FAILED =
  "[TAG_COLOR EDIT] EDIT_TAG_COLOR_FAILED";

export const GET_TAG_COLOR = "[TAG_COLOR EDIT] GET_TAG_COLOR";
export const GET_TAG_COLOR_SUCCESS =
  "[TAG_COLOR EDIT] GET_TAG_COLOR_SUCCESS";
export const GET_TAG_COLOR_FAILED =
  "[TAG_COLOR EDIT] GET_TAG_COLOR_FAILED";

export const SET_VALUE = "[TAG_COLOR EDIT] SET_VALUE";
export const CLEAR_VALUE = "[TAG_COLOR EDIT] CLEAR_VALUE";

export function getTagColor(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_TAG_COLOR
    });

    const { token } = getState().login;

    let response = await api.sendGet("/TagColor/" + id, {
      Authorization: "Bearer " + token
    });

    if (response.ok) {
      let json = await response.json();

      let item = json.model;
      dispatch({
        type: GET_TAG_COLOR_SUCCESS,
        payload: item
      });
    } else {
      dispatch({ type: GET_TAG_COLOR_FAILED });
    }
  };
}

export function editTagColor() {
  return async (dispatch, getState) => {
    dispatch({
      type: EDIT_TAG_COLOR
    });

    const { login, tagColorEdit } = getState();

    let { name, hexCode, active, item } = tagColorEdit;

    const errors = {};

    if (!name) errors.name = "Informe um nome";
    if (!hexCode) errors.hexCode = "Informe uma cor";

    dispatch(setValue({ errors }));

    if (_.keys(errors).length > 0)
      return dispatch({ type: EDIT_TAG_COLOR_FAILED });

    let response = await api.sendPut(
      "/TagColor/" + item.id,
      {
        ...item,
        name,
        hexCode,
        active
      },
      {
        Authorization: "Bearer " + login.token
      }
    );

    if (response.ok) {
      dispatch({
        type: EDIT_TAG_COLOR_SUCCESS
      });

      dispatch(clearValue());

      history.push("/TagColor");
    } else {
      dispatch({ type: EDIT_TAG_COLOR_FAILED });
    }
  };
}

export function setValue(payload) {
  return {
    type: SET_VALUE,
    payload
  };
}

export function clearValue() {
  return {
    type: CLEAR_VALUE
  };
}
